import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const inquirySchema = z.object({
  type: z.literal("contact").default("contact"),
  name: z.string().trim().min(1, "Name is required").max(100),
  email: z.string().trim().email("Enter a valid email").max(255),
  phone: z.string().trim().min(7, "Phone number is required").max(40),
  subject: z.string().trim().max(200).optional().or(z.literal("")),
  reason: z.string().trim().max(100).optional().or(z.literal("")),
  message: z.string().trim().min(1, "Message is required").max(4000),
});

export const submitInquiry = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => inquirySchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("inquiries").insert({
      type: data.type,
      name: data.name,
      email: data.email,
      phone: data.phone || null,
      subject: data.subject || null,
      reason: data.reason || null,
      message: data.message || null,
    });
    if (error) {
      console.error("submitInquiry", error);
      throw new Error("Could not save your message. Please email care@europeanwigluxury.com.");
    }
    return { ok: true };
  });
